import { cn } from '@/utils/cn'
import type { HTMLAttributes } from 'react'

export const Page = ({ className, ...props }: HTMLAttributes<HTMLDivElement>) => {
  return <div className={cn('flex h-full max-h-full flex-col overflow-hidden', className)} {...props} />
}

export const Content = ({ className, ...props }: HTMLAttributes<HTMLDivElement>) => {
  return (
    <div
      className={cn(
        'mx-auto w-full max-w-[1376px] p-4 md:p-6 xl:px-8',
        '[&:has(aside[data-role="side-panel"])]:max-w-[1856px]',
        className
      )}
      {...props}
    />
  )
}

export const TypographyContent = ({ className, ...props }: HTMLAttributes<HTMLDivElement>) => {
  return (
    <div
      className={cn(
        'prose max-w-none prose-headings:text-heading-foreground prose-p:text-body-foreground marker:text-heading-foreground',
        'marker:text-[inherit]',
        '[&_ol_li:has(h3)]:marker:text-xl [&_ol_li]:marker:[color:inherit] [&_ol_li_.title]:inline',
        className
      )}
      {...props}
    />
  )
}
